import { render, staticRenderFns } from "./CreateContactButton.vue?vue&type=template&id=13f3a762&scoped=true&lang=pug"
import script from "./CreateContactButton.vue?vue&type=script&lang=js"
export * from "./CreateContactButton.vue?vue&type=script&lang=js"
import style0 from "./CreateContactButton.vue?vue&type=style&index=0&id=13f3a762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f3a762",
  null
  
)

export default component.exports